import React from "react";
import Results from "../../../../ui/Results/Results";

export default function ViewResults() {
  return <Results role="Instructor" />;
}